import React, { useState, useContext } from 'react';
import "../../../ui-styles/tabStyles/HztlTabStyles.css"
import "../../../ui-styles/nodata/NoData.css";
import "../Styles.css";
import { LangCtx } from "../../../lib/context";


// COMPONENTS
import CreateSchedule from "./CreateSchedule";
import MySchedules from "./MySchedules";


const DoctorSchedules = (props) => {
    const [current, setTab] = useState("CS");
    const { l } = useContext(LangCtx);


    return <div className="baseContainer">
        <div className="tabCol">
            <div className="row hndlpdn08">
                <div className={current === "CS" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CS")}>
                    <span>{l.cr_sched}</span>
                </div>
                {/* <div className={current === "MS" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("MS")}>
                    <span>{l.my_sched}</span>
                </div> */}
            </div>
        </div>
        {current === "CS" && <CreateSchedule />}
        {current === "MS" && <MySchedules />}
    </div>
}

export default DoctorSchedules;